module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "loi"
    }
  }), _vm._v("LIST OF ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/09_introduction#figure01"
    }
  }, [_vm._v("A high-level overview of the components")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/10_chapter01#figure02"
    }
  }, [_vm._v("The most successful and productive organizations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/10_chapter01#figure03"
    }
  }, [_vm._v("A-B-Cs of accountability hierarchies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter02#figure04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The purpose of leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter02#figure05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maximum effectiveness in a role requires full role mastery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter03#figure06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naturally occurring, discrete levels of complexity require")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter03#figure07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naturally occurring, discrete levels of complexity exist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter04#figure08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Different types of decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter04#figure09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Achieving optimal fit of person to role")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter04#figure10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Applying the science behind the maturation of potential")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter04#figure11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Otherwise qualified employees may pull their roles down")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter05#figure12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The art of organizational design requires aligning levels, functions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter05#figure13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aligning employees' thinking and decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter05#figure14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aligning employees' thinking and lateral collaboration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter05#figure15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ensuring optimal collaboration among cross-functional employees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter06#figure16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For managers to be accountable for their teams outputs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter06#figure17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Accountability for the outputs of teams varies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter07#figure18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For a business-unit head role to be fully accountable for its success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter07#figure19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The first step in organizational design")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter08#figure20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To ensure robust cross-functional collaboration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter08#figure21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There is a hierarchy of indirect accountabilities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter08#figure22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To reduce the need for micromanagement, avoid matrix solutions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/17_chapter08#figure23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Managers are accountable for the outputs of their subordinates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter08#figure24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A “process owner” is the first managerial role up the hierarchy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter09#figure25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“True process owners” can delegate system stewardship authority")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10#figure26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Accurate and comprehensive role specifications")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10#figure27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By precisely defining each role's work requirements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10#figure28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assessing the effectiveness with which an employee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#figure29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strategic Organization Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#figure30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Applying the “science” of levels of work complexity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#figure31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solid, commonsense “organization engineering principles”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#figure32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strategic Organization principles and practices")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c47fca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_listofillustrations.vue
// module id = 72
// module chunks = 0